import { AppState } from '../rootReducer';
import { ProgramLinkState } from './types';

export const getProgramLinkState = (state: AppState, programId: string): ProgramLinkState | undefined =>
  state.comoLink[programId];
